$(document).ready( function () {
  $("body").on('focus', 'input, select, textarea, checkbox', function () {
    $(this).attr('autocomplete', 'off');
    $(this).parent().find('div.invalid-feedback').hide('slow');
  });
  if (document.querySelectorAll('#founders_card_register_step_one').length){
    const step_one_form = document.querySelector("#founders_card_register_step_one");
    step_one_form.addEventListener("ajax:success", (event) => {
      const [data, _status, xhr] = event.detail;
      window.location = data.message
    });

    step_one_form.addEventListener("ajax:error", (event) => {
      const [data, _status, xhr] = event.detail;
      $.each(data.errors, function (field, errors) {
        $('#founders_card_customer_' + field).parent().find('div.invalid-feedback').remove();
        $('#founders_card_customer_' + field).parent().append('<div class="invalid-feedback">' + errors[0] + '</div>');
        $('#founders_card_customer_' + field).parent().find('div.invalid-feedback').show('slow');
      });
    });
  }

  // # OTP AJAX
  $("body").on('click', '#founders_card_get-otp', function () {
    $('#founders_card_otp-status').remove();
    const phone_no = $('#founders_card_customer_mobile_no').val();
    $.ajax({
      type: "post",
      url: '/founders-card-send_otp',
      data: { "phone_no": phone_no },
      success: function (response) {
        if (response.success) {
          $('#founders_card_customer_mobile_no').parent().after('<span class="text-success" id="founders_card_otp-status">' + response.message + '</span>')
        } else {
          $('#founders_card_customer_mobile_no').parent().after('<span class="text-danger" id="founders_card_otp-status">' + response.message + '</span>')
        }
      },
    });
  });


  if (document.querySelectorAll('#founders_card_register_step_two').length){
    const step_two_form = document.querySelector("#founders_card_register_step_two");
    step_two_form.addEventListener("ajax:success", (event) => {
      const [data, _status, xhr] = event.detail;
      window.location = data.message
    });

    step_two_form.addEventListener("ajax:error", (event) => {
      const [data, _status, xhr] = event.detail;
      $.each(data.errors, function (field, errors) {
        $('#' + field).parent().find('div.invalid-feedback').remove();
        $('#' + field).parent().append('<div class="invalid-feedback">' + errors[0] + '</div>');
        $('#' + field).parent().find('div.invalid-feedback').show('slow');
      });
    });
  }

});

// Get GST details from GSTIN
function founders_card_get_gst_info(gstno){
  const customer_lead_id = $('#customer_lead_id').val();
  $.post('/founders-card-gst-info-from-gstin', { gst: gstno, id: customer_lead_id })
    .done(function (data) {
      if(data.success){
        $('#founders_card_company_name').val(data.name).attr('readonly', true);
        $('#founders_card_company_type').val(data.business_type).attr('readonly', true);
        $('#founders_card_company_registered_address').val(data.address).attr('readonly', true);
        $('#founders_card_company_registered_pin_code').val(data.pin).attr('readonly', true);
        $('#founders_card_company_gst_no').val(data.gstin).attr('readonly', true);

        if ($('#sameAddress').prop("checked")){
          $('#founders_card_company_current_address').val($('#founders_card_founders_card_company_registered_address').val()).attr('readonly', true);
          $('#founders_card_company_current_pin_code').val($('#founders_card_founders_card_company_registered_pin_code').val()).attr('readonly', true);
        }
      }else{
        $('#founders_card_company_name').attr('readonly', false);
        $('#founders_card_company_type').attr('readonly', false);
        $('#founders_card_company_registered_address').attr('readonly', false);
        $('#founders_card_company_registered_pin_code').attr('readonly', false);
        $('#founders_card_company_gst_no').attr('readonly', false);
      }
  });
}


$("body").on('click', '#founders_card_pan-details', function () {
  $('#founders_card_company_pan').val($('#founders_card_company_pan').val().toUpperCase());
  $('#founders_card_company_pan').parent().find('div.invalid-feedback').remove();
  $('#founders_card_company_name').parent().find('div.invalid-feedback').remove();
  $('#founders_card_company_type').parent().find('div.invalid-feedback').remove();
  $('#founders_card_company_registered_address').parent().find('div.invalid-feedback').remove();
  $('#founders_card_company_registered_pin_code').parent().find('div.invalid-feedback').remove();
  $('#founders_card_company_gst_no').parent().find('div.invalid-feedback').remove();
  $('#founders_card_company_current_pin_code').parent().find('div.invalid-feedback').remove();
  $('#founders_card_company_current_address').parent().find('div.invalid-feedback').remove();

  $('#founders_card_no-gst').hide();
  $('#founders_card_gstin-numbers').html('');
  $('#founders_card_multi-gstno').hide();
  $('#founders_card_company_name').val('');
  $('#founders_card_company_type').val('');
  $('#founders_card_company_registered_address').val('');
  $('#founders_card_company_registered_pin_code').val('');
  $('#founders_card_company_gst_no').val('');

  $('#founders_card_company_current_address').val('');
  $('#founders_card_company_current_pin_code').val('');

  var panNumber = $('#founders_card_company_pan').val().toUpperCase();;
  if (!panNumber) {
    $('#founders_card_company_pan').parent().append('<div class="invalid-feedback">PAN Number required</div>');
    $('#founders_card_company_pan').parent().find('div.invalid-feedback').show('slow');
    return;
  }

  re = new RegExp("[A-Z]{5}[0-9]{4}[A-Z]{1}");
  if (!re.test(panNumber)) {
    $('#founders_card_company_pan').parent().append('<div class="invalid-feedback">Invalid PAN Number.</div>');
    $('#founders_card_company_pan').parent().find('div.invalid-feedback').show('slow');
    return;
  }
  // Get GSTINs from PAN
  $.post('/founders-card-gst-search-from-pan', { pan: panNumber })
    .done(function (data) {
      $('#founders_card_company_pan').parent().find('div.invalid-feedback').remove();
      if(data.success){
        $('.gst_auth').show();
        $('.same-address-div').show();
        if(data.active_gstins.length == 1){
          $('#founders_card_multi-gstno').hide();
          founders_card_get_gst_info(data.active_gstins[0]);
        }else{
          $('#founders_card_gstin-number').html('');
          $('#founders_card_multi-gstno').show();
          $.each(data.active_gstins, function(key, val){
            var html = '<div class="form-check form-check-inline">';
            html += '<input class="form-check-input gstno-select" type="radio" name="gstno" id="gst-radio-'+key+'" value="'+val+'">';
            html += '<label class="form-check-label" for="gst-radio-'+key+'">'+val+'</label></div>';
            $('#founders_card_gstin-numbers').append(html);
          });
        }
      }else{
        $('#founders_card_company_pan').parent().append('<div class="invalid-feedback">' + data.message + '</div>');
        $('#founders_card_company_pan').parent().find('div.invalid-feedback').show('slow');

        $('#founders_card_no-gst').show();

        $('#founders_card_company_name').attr('readonly', false);
        $('#founders_card_company_type').attr('readonly', false);
        $('#founders_card_company_registered_address').attr('readonly', false);
        $('#founders_card_company_registered_pin_code').attr('readonly', false);
        $('#founders_card_company_gst_no').attr('readonly', false);
      }
  });
  $('body').on('click', '.gstno-select', function(){
    founders_card_get_gst_info($(this).val())
  });
});

$('body').on('click', '#sameAddress', function(){
  $('#founders_card_company_current_pin_code').parent().find('div.invalid-feedback').remove();
  $('#founders_card_company_current_address').parent().find('div.invalid-feedback').remove();
  if ($(this).prop("checked")){
    $('#founders_card_company_current_address').val($('#founders_card_company_registered_address').val()).attr('readonly', true);
    $('#founders_card_company_current_pin_code').val($('#founders_card_company_registered_pin_code').val()).attr('readonly', true);
  }else{
    $('#founders_card_company_current_address').val('').attr('readonly', false);
    $('#founders_card_company_current_pin_code').val('').attr('readonly', false)
  }
});

if($('#founders_card_company_registered_pin_code').val() == $('#founders_card_company_current_pin_code').val()){
  // $('#sameAddress').prop("checked", true);
  $('#founders_card_company_current_address').val($('#founders_card_company_registered_address').val()).attr('readonly', true);
  $('#founders_card_company_current_pin_code').val($('#founders_card_company_registered_pin_code').val()).attr('readonly', true);
}

var requestId;
 // # Request for GST OTP AJAX
$("body").on('click', '#founders_card_generate-gst-otp', function () {
  $('.gst-response').remove();
  const gst_username = $('#founders_card_gst-username').val();
  const gstin = $('#founders_card_company_gst_no').val();
  $.ajax({
    type: "post",
    url: '/founders-card-gst-details-send-otp',
    data: { "username": gst_username, "gstin": gstin },
    success: function (response) {
      const message = response.message
      if (response.success) {
        requestId = response.request_id
        $("#founders_card_gst-request-id").val(requestId);
        $('#founders_card_generate-gst-otp').parent().append('<span class="text-success gst-response" id="submit-otp-success">' + message + '</span>')
      } else {
        $('#founders_card_generate-gst-otp').parent().append('<span class="text-danger gst-response" id="submit-otp-failure">' + message + '</span>')
      }
    },
  });
});

// Submit GST OTP for report fetching
$("body").on('click', '#founders_card_submit-gst-otp', function () {
  $('.founders_card_gst-response').remove();
  $('#founders_card_gst-fetch-loader').show();
  const otp = $('#founders_card_gst-otp').val();
  const requestId = requestId;
  const customer_lead_id = $('#customer_lead_id').val();
  const gst_request_id = $('#founders_card_gst-request-id').val();
  const company_gst_no = $('#founders_card_company_gst_no').val();
  $.ajax({
    type: "post",
    url: '/founders-card-gst-details-otp-based',
    data: { "otp": otp, "requestId": gst_request_id, "customer_lead_id": customer_lead_id, "company_gst_no": company_gst_no },
    success: function (response) {
      console.log(response)
      console.log(response.message)
      const message = response.message
      if (response.success) {
        $('#founders_card_gst-fetch-loader').hide();
        $('#founders_card_submit-gst-otp').parent().append('<span class="text-success gst-response" id="gst-report-success">' + message + '</span>')
      } else {
        $('#founders_card_gst-fetch-loader').hide();
        $('#founders_card_submit-gst-otp').parent().append('<span class="text-danger gst-response" id="gst-report-failure">' + message + '</span>')
      }
    },
  });
});

$(document).ready(function() {
  $(window).keydown(function(event){
    if(event.keyCode == 13) {
      event.preventDefault();
      return false;
    }
  });
});

document.addEventListener('turbolinks:load', function() {
  $('.custom-file-input').change(function(e){
    var fileName = e.target.files[0].name;
    fileLabel = $(`.custom-file-label[for=${e.currentTarget['id']}]`);
    if(fileLabel && fileLabel[0]) {
      fileLabel[0].textContent = fileName.replace(/^.*[\\\/]/, '');
    }
  });
}, false);

$("body").on('click', '#founders_card_registration_form_2_submit', function () {
  $('#founders_card_register_step_two').submit();
});
